import { useNavigate } from 'react-router-dom';
import React from 'react';
import { Space, Typography } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const BackLink = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onGoBack = () => {
    navigate(-1);
  };

  return (
    <Space
      id='back-link'
      onClick={onGoBack}
      size={10}
      style={{ cursor: 'pointer', marginBottom: 20 }}
    >
      <LeftOutlined style={{ fontSize: 18 }} color='#9989C7' />
      <Typography style={{ fontWeight: 400 }}>{t('button.back')}</Typography>
    </Space>
  );
};

export default BackLink;
